import { LoadingStatuses } from 'core/common/entities';
import { Web2AppLinkType } from 'core/user/entities';

export const getWeb2AppLinkType = (linkStatus: LoadingStatuses): Web2AppLinkType =>
  linkStatus === LoadingStatuses.FULFILLED
    ? Web2AppLinkType.PERSONALIZED
    : Web2AppLinkType.FALLBACK;
